module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_craig_sm-ea9881b89bf23d792d7e6751a0e55093.png";